/** Display names only; stored job titles and authorization roles are never changed. */
const titles: ReadonlyArray<readonly [string, string]> = [
  ['Executive Manager', 'مدير تنفيذي'], ['Chief Executive Officer', 'الرئيس التنفيذي'],
  ['General Manager', 'مدير عام'], ['Operations Manager', 'مدير العمليات'],
  ['Sales Manager', 'مدير المبيعات'], ['Team Leader', 'قائد الفريق'],
  ['Sales Agent', 'موظف مبيعات'], ['Tele-Sales', 'موظف المبيعات الهاتفية'],
  ['Receptionist', 'موظف استقبال'], ['Reception Manager', 'مدير الاستقبال'],
  ['HR Manager', 'مدير الموارد البشرية'], ['HR Specialist', 'أخصائي الموارد البشرية'],
  ['Accountant', 'محاسب'], ['Finance Manager', 'مدير الحسابات'],
  ['Marketing Manager', 'مدير التسويق'], ['Marketing Specialist', 'أخصائي التسويق'],
  ['Moderator', 'مودريتور'],
  ['Instructor', 'محاضر'], ['Training Manager', 'مدير التدريب'], ['Developer', 'مطور'],
];
export function localizeJobTitle(title: string, language: 'en' | 'ar'): string {
  const normalized = title.trim().toLocaleLowerCase().replace(/^ال(?=مدير)/, '').replace('تتنفيذي', 'تنفيذي');
  const pair = titles.find(([en, ar]) => en.toLocaleLowerCase() === normalized || ar === normalized);
  return pair ? pair[language === 'ar' ? 1 : 0] : title;
}
